module.exports = __webpack_public_path__ + "static/media/id-example.d27b636e.svg";